import {Action} from 'redux';
import {createAction} from '@reduxjs/toolkit';

import {SurveyStore} from 'client/common/store/reducers/survey/types';

export const setSurvey = createAction<Partial<SurveyStore>>('SET_SURVEY');
export const fetchSurvey = createAction<string | undefined>('FETCH_SURVEY');
export const createSurvey = createAction<SurveyPayload | undefined>('CREATE_SURVEY');
export const updateSurvey = createAction<SurveyPayload | undefined>('UPDATE_SURVEY');
export const hasChanges = createAction<SurveyPayload>('HAS_CHANGES');

interface SurveyPayload {
    reqId?: string;
}

export interface SetSurveyAction extends Action {
    payload: SurveyStore;
}
